export default "<div *ngIf=\"active\"><ng-content></ng-content></div>\n"